function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { setForLargeScreen, setForMediumScreen } from 'swag-client-common/styles/admin-layout-helpers-js';
import { variables } from 'swag-client-common/styles/variables-js';
export const LINK_STYLES_COMMON = {
  fontWeight: 400,
  color: `${variables.colorTextGrey} !important`,
  opacity: 1,
  fontFamily: variables.fontFamilyBold,
  letterSpacing: 0
};
export const LINK_STYLES_FIXED = {
  fontSize: '15px',
  padding: '30px 0',
  lineHeight: '26px'
};
export const LINK_STYLES_FLEXIBLE = {
  fontSize: setForMediumScreen(15),
  padding: `${setForMediumScreen(30)} 0`,
  lineHeight: setForMediumScreen(26)
};
export const LINK_STYLES_FLEXIBLE_BIG = {
  fontSize: setForLargeScreen(15),
  padding: `${setForLargeScreen(30)} 0`,
  lineHeight: setForLargeScreen(26)
};
export const LINK_STYLES_MOBILE = {
  fontSize: '15px',
  padding: '15px 0',
  lineHeight: '26px'
};
export function getTabStyles({
  isMobileScreen,
  isLargeScreen,
  isFixed
}) {
  if (isMobileScreen) {
    return _objectSpread({}, LINK_STYLES_COMMON, LINK_STYLES_MOBILE);
  }
  if (isFixed) {
    return _objectSpread({}, LINK_STYLES_COMMON, LINK_STYLES_FIXED);
  }
  return _objectSpread({}, LINK_STYLES_COMMON, isLargeScreen ? LINK_STYLES_FLEXIBLE_BIG : LINK_STYLES_FLEXIBLE);
}